import React from 'react'

const CheckIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={20}
                height={20}
                x={0}
                y={0}
                viewBox="0 0 60 60"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#60a9eb"
                        d="M59 30c0 16.632-13.99 29.987-30.848 28.943-14.444-.895-26.2-12.651-27.094-27.095C.013 14.99 13.368 1 30 1a28.85 28.85 0 0 1 12.74 2.941c1.031.506 1.409 1.79.84 2.788l-.004.007a1.998 1.998 0 0 1-2.626.796c-3.818-1.88-8.183-2.795-12.79-2.466-12.1.863-21.982 10.568-23.059 22.651-1.34 15.039 10.712 27.662 25.563 27.274 12.718-.332 23.334-10.418 24.265-23.106a24.863 24.863 0 0 0-1.099-9.429 1.985 1.985 0 0 1 1.012-2.378c1.094-.547 2.435 0 2.806 1.165A28.849 28.849 0 0 1 58.999 30z"
                        opacity={1}
                        data-original="#aee090"
                        className=""
                    />
                    <path
                        fill="#1975c9"
                        d="m15.41 22.472 15.814 21.397a2.763 2.763 0 0 0 4.631-.266L58.707 4.045c1.19-2.06-1.525-4.131-3.144-2.397L31.755 27.15l-13.814-7.646c-1.867-1.033-3.807 1.241-2.531 2.968z"
                        opacity={1}
                        data-original="#6bb577"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default CheckIcon